import axiosInstance from 'api/axiosInstance';

export interface CheckpointStatsParams {
  CustomerId: string | number;
  FromDate: string;
  ToDate: string;
  AddressId: string | number;
}

export interface CheckpointStatsResponse {
  total: number;
  clear: number;
  warning: number;
  emergency: number;
  info: number;
  incomplete: number;
}

export const getCheckpointStats = async (
  params: CheckpointStatsParams
): Promise<CheckpointStatsResponse> => {
  try {
    const response = await axiosInstance.get(
      '/api/activityreportcontroller/GetCheckpointStats',
      {
        params: params,
        paramsSerializer: (params) => `payload=${JSON.stringify(params)}`,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
        data: null,
      }
    );

    return response.data || { total: 0, clear: 0, warning: 0, emergency: 0, info: 0, incomplete: 0 };
  } catch (error) {
    console.error('Error fetching checkpoint stats:', error);
    throw error;
  }
};

export default getCheckpointStats;
